import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Grid, Paper, Button, Box } from '@material-ui/core';
import { List, ListItem, ListItemText } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { updateUser } from '../redux/userDbSlice';
import useAllLanguageDbs from '../hooks/useAllLanguageDbs';
import useCurrentUserDb from '../hooks/useCurrentUserDb';
import Redirector from './Redirector';
import DigimagiAppBar from './DigimagiAppBar';

const WrapperGrid = styled(Grid)`
  padding: 60px 40px 24px;
  height: inherit;
`
const ChangeUserLanguageScenePaper = styled(Paper)`
  height: max(100%, 100vh);
`
const LanguageBox = styled(Box)`
  width: min(100%, 240px);
`
const PlainLink = styled(Link)`
  text-decoration: none;
`

type SimpleListProps = {
  selectingId: string | undefined,
  onSelect: (id: string) => void
}
const SimpleList: React.FC<SimpleListProps> = ({selectingId, onSelect}) => {
  const [ids, languages] = useAllLanguageDbs();

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    id: string
  ) => {
    onSelect(id);
  }

  return (
    <LanguageBox>
      <List component="nav">
        { ids.map((id, ix) =>
          <ListItem button selected={selectingId === id} key={id}
            onClick={(ev) => handleListItemClick(ev, id)}>
            <ListItemText primary={languages[ix].name} key={id} />
          </ListItem>
        ) }
      </List>
    </LanguageBox>
  );
}

type ChangeUserLanguageSceneProps = {
  redirected: boolean;
  setRedirected: (value: boolean) => void;
}
const ChangeUserLanguageScene: React.FC<ChangeUserLanguageSceneProps> = ({ redirected, setRedirected }) => {
  const dispatch = useDispatch();
  const [userId, currentUser] = useCurrentUserDb();
  const [selectingId, setSelectingId] = useState<string | undefined>(currentUser?.language);

  const changeUserLanguage = () => {
    dispatch(updateUser({id: userId || 'no user', language: selectingId}));
  }

  useEffect(() => {
    setSelectingId(currentUser?.language);
  }, [currentUser])

  if (!redirected) return <Redirector doneRedirect={() => setRedirected(true)} />;
  else return (
    <>
      <DigimagiAppBar setRedirected={setRedirected} parent='UserSettings' />
      <Grid container>
        <Grid item container>
          <Grid item md={12}>
            <ChangeUserLanguageScenePaper square>
              <WrapperGrid container>
                <Grid item xs={12}>
                  <SimpleList selectingId={selectingId} onSelect={(id: string) => setSelectingId(id)} />
                </Grid>
                <Grid item xs={12} container justifyContent="flex-end" spacing={2}>
                  <Grid item>
                    <PlainLink to="/userSettings">
                      <Button color='primary'>キャンセル</Button>
                    </PlainLink>
                  </Grid>
                  <Grid item>
                    <PlainLink to="/userSettings">
                      <Button color='primary' onClick={changeUserLanguage}>決定する</Button>
                    </PlainLink>
                  </Grid>
                </Grid>
              </WrapperGrid>
            </ChangeUserLanguageScenePaper>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default ChangeUserLanguageScene;
